/// <amd-module name="SuiteCommerce.GiftCertificate.ValueCheck.Model"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.GiftCertificate.ValueCheck.Model", ["require", "exports", "SuiteCommerce.GiftCertificate.Instrumentation", "SuiteCommerce.GiftCertificate.ValueCheck.Configuration", "SuiteCommerce.GiftCertificate.Model"], function (require, exports, Instrumentation_1, ValueCheck_Configuration_1, GiftCertificate_Model_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ValueCheckModel = exports.GiftCertificateStatus = void 0;
    var GiftCertificateStatus;
    (function (GiftCertificateStatus) {
        GiftCertificateStatus["active"] = "ACTIVE";
        GiftCertificateStatus["expired"] = "EXPIRED";
        GiftCertificateStatus["inactive"] = "INACTIVE";
        GiftCertificateStatus["invalid"] = "INVALID";
    })(GiftCertificateStatus || (exports.GiftCertificateStatus = GiftCertificateStatus = {}));
    var ValueCheckModel = /** @class */ (function (_super) {
        __extends(ValueCheckModel, _super);
        function ValueCheckModel() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.urlRoot = '/app/site/hosting/scriptlet.nl?script=customscript_ns_sc_sl_gift_cert_mgmt' +
                '&deploy=customdeploy_ns_sc_sl_gift_cert_mgmt';
            _this.validation = {
                giftcertcode: {
                    required: true,
                    minLength: ValueCheck_Configuration_1.ValueCheckConfiguration.inputFieldMinLength,
                    maxLength: ValueCheck_Configuration_1.ValueCheckConfiguration.inputFieldMaxLength,
                    msg: ValueCheck_Configuration_1.ValueCheckConfiguration.invalidCodeFieldHelp,
                },
            };
            return _this;
        }
        ValueCheckModel.prototype.getGiftCertificateData = function () {
            var giftCertificateRequestLog = Instrumentation_1.default.getLog('giftCertificateRequestLog');
            giftCertificateRequestLog.startTimer();
            this.unset('result', { silent: true });
            return this.fetch({
                data: {
                    giftcertcode: this.get('giftcertcode'),
                },
            }).done(function () {
                giftCertificateRequestLog.endTimer();
                giftCertificateRequestLog.setParameters({
                    activity: 'Time it takes load gift certificate data',
                    totalTime: giftCertificateRequestLog.getElapsedTimeForTimer(),
                });
                giftCertificateRequestLog.submit();
            });
        };
        return ValueCheckModel;
    }(GiftCertificate_Model_1.GiftCertificateModel));
    exports.ValueCheckModel = ValueCheckModel;
});
